import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
export default class WriterException extends Exception {
}
WriterException.kind = 'WriterException';
//# sourceMappingURL=WriterException.js.map